import React from 'react';

const EverscaleLogo = ({ size = 20 }: { size?: number }) => {
	return (
		<svg
			height={size}
			width={size}
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 26.3 26.3"
		>
			<path
				style={{
					fillRule: 'evenodd',
					clipRule: 'evenodd',
					fill: '#6347F5',
				}}
				className="st0"
				d="M17.1,26.3l9.2-9.1V0H9.1L0,9.2h17.1L17.1,26.3z"
			/>
		</svg>
	);
};

export default EverscaleLogo;
